export type JobType = 'FM' | 'QC' | 'RWI' | 'SC' | 'standard';

export const JOB_TYPES: JobType[] = ['FM', 'QC', 'RWI', 'SC', 'standard'];